// // Form Validation Library : https://www.npmjs.com/package/react-form-input-validation
// // https://www.npmjs.com/package/validatorjs

// mobile ready with age and Terms checkbox
import React, { useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import { IconContext } from 'react-icons/lib';
import { FaBars } from 'react-icons/fa';
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Typography,
  Menu,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  IconButton,
  Checkbox,
  FormControlLabel,
  InputAdornment,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

function SpLogin({ spLoggedIn, setSpLoggedIn, client, setClient, spId, setSpId }) {
  // console.log('setClient:', setClient);
  // console.log('typeof setClient:', typeof setClient);
  const history = useHistory();

  // UI state
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openSpLogin, setOpenSpLogin] = useState(false);
  const [openSpSignup, setOpenSpSignup] = useState(false);
  const [mobileOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // Login form state
  const [loginFields, setLoginFields] = useState({
    email_address: '',
    password: '',
  });
  const [loginErrors, setLoginErrors] = useState({});

  // Signup form state
  const [signupFields, setSignupFields] = useState({
    email_address: '',
    password: '',
    password_confirmation: '',
    firstName: '',
    lastName: '',
    gender: '',
    mobile: '',
    dob: '',
  });
  const [signupErrors, setSignupErrors] = useState({});
  const [spSignupErrors, setSpSignupErrors] = useState([]); // server errors
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  // Helpers
  const isEmail = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
  const isNumeric = (s) => /^[0-9]+$/.test(s);

  function calculateAgeFromDob(dobValue) {
    if (!dobValue) return null;
    const dob = new Date(dobValue);
    if (Number.isNaN(dob.getTime())) return null;
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
    return age;
  }

  // Menu handlers
  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  // Dialog open/close
  const onOpenSpLoginModal = () => setOpenSpLogin(true);
  const onCloseSpLoginModal = () => setOpenSpLogin(false);
  const onOpenSpSignupModal = () => setOpenSpSignup(true);
  const onCloseSpSignupModal = () => setOpenSpSignup(false);

  // Generic onChange handlers
  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginFields((s) => ({ ...s, [name]: value }));
    setLoginErrors((s) => ({ ...s, [name]: undefined }));
  };

  const handleSignupChange = (e) => {
    const { name, value, type, checked } = e.target;
    // For checkbox we use acceptedTerms separately
    setSignupFields((s) => ({ ...s, [name]: value }));
    setSignupErrors((s) => ({ ...s, [name]: undefined }));
  };

  // Validations
  const validateLogin = () => {
    const errs = {};
    if (!loginFields.email_address) errs.email_address = 'Email is required';
    else if (!isEmail(loginFields.email_address)) errs.email_address = 'Invalid email';
    if (!loginFields.password) errs.password = 'Password is required';

    setLoginErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const validateSignup = () => {
    const errs = {};
    const f = signupFields;

    if (!f.email_address) errs.email_address = 'Email is required';
    else if (!isEmail(f.email_address)) errs.email_address = 'Invalid email';

    if (!f.password) errs.password = 'Password is required';
    if (!f.password_confirmation) errs.password_confirmation = 'Confirm password';
    if (f.password && f.password_confirmation && f.password !== f.password_confirmation)
      errs.password_confirmation = 'Passwords do not match';

    if (!f.firstName) errs.firstName = 'First name is required';
    if (!f.lastName) errs.lastName = 'Last name is required';

    if (!f.gender && f.gender !== 0 && f.gender !== '0') errs.gender = 'Gender is required';

    if (!f.dob) errs.dob = 'Date of birth is required';
    else {
      const age = calculateAgeFromDob(f.dob);
      if (age === null) errs.dob = 'Invalid date';
      else if (age < 18) errs.dob = 'You must be 18 years or older';
    }

    if (!f.mobile) errs.mobile = 'Mobile is required';
    else if (!isNumeric(f.mobile) || f.mobile.length !== 10) errs.mobile = 'Enter a 10 digit mobile number';

    if (!acceptedTerms) errs.terms = 'You must accept Terms & Conditions';

    setSignupErrors(errs);
    return Object.keys(errs).length === 0;
  };

  // Submissions
  const handleSubmitSpLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    // if (!validateLogin()) return;
    // console.log('setClient:', setClient);
    // console.log('typeof setClient:', typeof setClient);
    const loginUrl = process.env.REACT_APP_SERVER
      ? 'https://salonserver-k8m8.onrender.com/login'
      : 'http://localhost:3001/login';

    try {
      const response = await axios.post(loginUrl, {
        user: {
          email: loginFields.email_address,
          password: loginFields.password,
        },
      });


      if (response.data.data.usertype === 'client') {
        alert('It seems you are registered as Client. Please register as Salon Owner to proceed.');
        return;
      }
      console.log('login res', response);
      localStorage.setItem('token', response.headers['authorization']);
      localStorage.setItem('spOwner', JSON.stringify(response.data.data));
      if (response.data.data.salon_id) {
        localStorage.setItem('spSalonId', response.data.data.salon_id);
      }
      localStorage.setItem('spLoggedIn', 'true');

      setSpLoggedIn(true);
      setClient(false);
      setSpId(response.data.data.id);

      onCloseSpLoginModal();
      history.push('/dashboard');
    } catch (err) {
      if (err.response?.status === 401) {
        console.log('login error', err);
        alert('Invalid email or password');
      }
      console.log('sp in err', err);
      console.error(err);
      alert(err.response?.data?.status?.message || 'Login failed');
      onCloseSpLoginModal();
    }
    finally {
      setLoading(false);
    }
  };

  // localStorage.setItem('spSalonId', response.data.data.salon_id);
  // localStorage.setItem('spOwner', JSON.stringify(response.data.data));

  const handleSubmitSpSignup = async (event) => {
    event.preventDefault();
    if (!validateSignup()) return;

    setLoading(true);
    const emailData = {
      "subject": 'Service Provider Registration Success!',
      "name": signupFields.firstName,
      "email": signupFields.email_address,
      "message":
        "Dear " +
        signupFields.firstName +
        ",\n\n" +
        "Thank you for registering with GroomWell Digital Services. Now you can login and fill the details of your Salon and Services\n"
        + "For any queries please contact Customer Care." +
        "\n\n" +
        "Team GroomWell"
    }

    const signUpUrl = process.env.REACT_APP_SERVER
      ? 'https://salonserver-k8m8.onrender.com/signup'
      : 'http://localhost:3001/signup';

    try {
      const response = await axios.post(signUpUrl, {
        // user:
        // {
        email: signupFields.email_address,
        password: signupFields.password,
        first_name: signupFields.firstName,
        last_name: signupFields.lastName,
        gender: parseInt(signupFields.gender, 10),
        mobile: signupFields.mobile,
        date_of_birth: signupFields.dob,
        usertype: 1,
        // },
      });

      console.log('signup res', response);
      const token = response.headers['authorization'];
      localStorage.setItem('token', token);
      // localStorage.setItem('spSalonId', response.data.data.salon_id);
      localStorage.setItem('spOwner', JSON.stringify(response.data.data));
      localStorage.setItem('spLoggedIn', 'true');

      setSpId(response.data.data.id);
      setSpLoggedIn(true);
      setClient(false);
      onCloseSpSignupModal();








      // const jwt = localStorage.getItem('token')
      // const spcontactsUrl = (process.env.REACT_APP_SERVER) ? `https://salonserver-k8m8.onrender.com/spcontacts` : `http://localhost:3001/spcontacts`
      // try {
      //   const res = axios.post(spcontactsUrl, emailData,
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //         "Accept": "application/json",
      //         "Authorization": ` ${localStorage.getItem("token")} `,
      //       },
      //     }
      //   );
      // }
      // catch (error) {
      // }

      alert('Registration successful. Please check your email. If not received pl call us');
      history.push('/dashboard');




    } catch (err) {
      const errors = err.response?.data?.status?.errors || ['Something went wrong. Please try again.'];
      setSpSignupErrors(errors);
      alert(errors.join(', '));
      onCloseSpSignupModal();
    } finally {
      setLoading(false);
    }
  };

  const handleSpLogout = async () => {
    console.log('Logging out...');
    setClient(true);
    setSpLoggedIn(false);
    setSpId(null);

    localStorage.removeItem('spLoggedIn');
    localStorage.removeItem('spSalonId');
    localStorage.removeItem('spOwner');
    localStorage.removeItem('token');

    history.push('/');
  };


  return (
    <IconContext.Provider value={{ color: '#fc0703' }}>
      <AppBar
        position="static"
        sx={{
          backgroundColor: '#41b5efff',
          height: { xs: 40, md: 55 },
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h6" sx={{ fontWeight: 700, color: 'white' }}>
            Salon Owners login here
          </Typography>

          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
            {spLoggedIn ? (
              <Button variant="outlined" color="inherit" onClick={handleSpLogout}>
                Logout
              </Button>
            ) : (
              <>
                <Button variant="outlined" color="inherit" onClick={onOpenSpLoginModal}>
                  Login
                </Button>
                <Button variant="contained" sx={{ backgroundColor: '#9d55e6' }} onClick={onOpenSpSignupModal}>
                  Signup
                </Button>
              </>
            )}
          </Box>

          <IconButton onClick={handleMenuOpen} sx={{ display: { xs: 'block', md: 'none' } }}>
            <FaBars />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => {
          handleMenuClose();
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {spLoggedIn ? (
          <MenuItem
            onClick={() => {
              handleSpLogout();
              handleMenuClose();
            }}
          >
            Logout
          </MenuItem>
        ) : (
          <>
            <MenuItem
              onClick={() => {
                onOpenSpLoginModal();
                handleMenuClose();
              }}
              style={{ color: '#d21944ff' }}
            >
              Login
            </MenuItem>
            <MenuItem
              onClick={() => {
                onOpenSpSignupModal();
                handleMenuClose();
              }}
              style={{ color: '#d21944ff' }}
            >
              Signup
            </MenuItem>
          </>
        )}
      </Menu>

      {/* Login Dialog */}
      <Dialog open={openSpLogin} onClose={onCloseSpLoginModal} PaperProps={{ sx: { width: '90%', maxWidth: '400px', p: 2 } }}>
        <DialogTitle>Salon Owner Login</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmitSpLogin}>
            <TextField
              fullWidth
              label="Email"
              name="email_address"
              type="email"
              value={loginFields.email_address}
              onChange={handleLoginChange}
              error={!!loginErrors.email_address}
              helperText={loginErrors.email_address}
              margin="normal"
            />
            <TextField
              fullWidth
              label="Password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              value={loginFields.password}
              onChange={handleLoginChange}
              error={!!loginErrors.password}
              helperText={loginErrors.password}
              margin="normal"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton aria-label="toggle password visibility" onClick={() => setShowPassword((s) => !s)} edge="end" size="small">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Link to="/ForgotPassword" onClick={onCloseSpLoginModal} style={{ color: '#1976d2', display: 'block', margin: '8px 0' }}>
              Forgot Password
            </Link>
            <Button type="submit" variant="contained" fullWidth sx={{ mt: 2, backgroundColor: '#9d55e6' }}>
              Login
            </Button>
          </form>
        </DialogContent>
      </Dialog>

      {/* Signup Dialog */}
      <Dialog open={openSpSignup} onClose={onCloseSpSignupModal} PaperProps={{ sx: { width: '90%', maxWidth: '400px', p: 2 } }}>
        <DialogTitle>Salon Owner Signup</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmitSpSignup}>
            <TextField
              fullWidth
              label="Email"
              name="email_address"
              type="email"
              value={signupFields.email_address}
              onChange={handleSignupChange}
              error={!!signupErrors.email_address}
              helperText={signupErrors.email_address}
              margin="normal"
            />
            <TextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              value={signupFields.password}
              onChange={handleSignupChange}
              error={!!signupErrors.password}
              helperText={signupErrors.password}
              margin="normal"
            />
            <TextField
              fullWidth
              label="Confirm Password"
              name="password_confirmation"
              type="password"
              value={signupFields.password_confirmation}
              onChange={handleSignupChange}
              error={!!signupErrors.password_confirmation}
              helperText={signupErrors.password_confirmation}
              margin="normal"
            />
            <TextField
              fullWidth
              label="First Name"
              name="firstName"
              value={signupFields.firstName}
              onChange={handleSignupChange}
              error={!!signupErrors.firstName}
              helperText={signupErrors.firstName}
              margin="normal"
            />
            <TextField
              fullWidth
              label="Last Name"
              name="lastName"
              value={signupFields.lastName}
              onChange={handleSignupChange}
              error={!!signupErrors.lastName}
              helperText={signupErrors.lastName}
              margin="normal"
            />
            <FormControl fullWidth margin="normal" error={!!signupErrors.gender}>
              <InputLabel>Gender</InputLabel>
              <Select name="gender" value={signupFields.gender} onChange={handleSignupChange} label="Gender">
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="0">Female</MenuItem>
                <MenuItem value="1">Male</MenuItem>
              </Select>
              {signupErrors.gender && <Typography color="error">{signupErrors.gender}</Typography>}
            </FormControl>

            <TextField
              fullWidth
              label="Date of Birth"
              name="dob"
              type="date"
              value={signupFields.dob}
              onChange={handleSignupChange}
              error={!!signupErrors.dob}
              helperText={signupErrors.dob}
              margin="normal"
              InputLabelProps={{ shrink: true }}
            />

            <TextField
              fullWidth
              label="Mobile"
              name="mobile"
              type="tel"
              value={signupFields.mobile}
              onChange={handleSignupChange}
              error={!!signupErrors.mobile}
              helperText={signupErrors.mobile}
              margin="normal"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={acceptedTerms} // boolean (fixes your prop warning)
                  onChange={(e) => {
                    setAcceptedTerms(e.target.checked);
                    setSignupErrors((s) => ({ ...s, terms: undefined }));
                  }}
                />
              }
              label={
                <Typography variant="body2">
                  I accept the{' '}
                  <Link to="/OwnersTerms" style={{ color: '#1976d2', textDecoration: 'none' }} onClick={onCloseSpSignupModal}>
                    Terms & Conditions
                  </Link>
                </Typography>
              }
            />
            {signupErrors.terms && <Typography color="error" variant="caption" display="block">{signupErrors.terms}</Typography>}

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 2, backgroundColor: '#9d55e6' }}
              disabled={!acceptedTerms} // disable when terms not accepted
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Sign Up"
              )}
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </IconContext.Provider>
  );
}

export default SpLogin;


// const logoutUrl = process.env.REACT_APP_SERVER
//   ? 'https://salonserver-k8m8.onrender.com/logout'
//   : 'http://localhost:3001/logout';

// try {
//   const response = await axios.delete(logoutUrl, {
//     headers: { Authorization: localStorage.getItem('token') },
//   });
//   setSpLoggedIn(false);
//   setClient(true);
//   localStorage.clear();
//   alert(response.data.message);
//   history.push('/');
// } catch {
//   setSpLoggedIn(false);
//   setClient(true);
//   localStorage.clear();
//   alert('Session expired. Please log in again.');
//   history.push('/');
// }